import React, { FC } from "react";


type GeneralConditionSkuProps = {
  info: any;
};

const GeneralConditionSku: FC<GeneralConditionSkuProps> = (props) => {
  return (
   <div>Hi</div>
  );
};

export default GeneralConditionSku;
